import { ROLES } from "@/data/DefaultSettings";
import { fetchHil, fetchHil2 } from "../utils";

export default {
  namespaced: true,
  state: {
    isLogged: false,
    initialized: false,
    id: null,
    createdAt: null,
    role: null,
    projectId: null,
    billing: {
      outstanding: [],
      history: []
    },
    rewards: {
      custom: 0
    }
  },
  getters: {
    isSuperAdmin: state => state.role === ROLES.SUPERADMIN,
    isAdmin: state => state.role === ROLES.ADMIN,
    isAdminOrSuperAdmin: state =>
      state.role === ROLES.ADMIN || state.role === ROLES.SUPERADMIN,
    isUser: state => state.role === ROLES.USER
  },
  mutations: {
    setUserStatus(state, object) {
      for (const k of Object.keys(object)) {
        state[k] = object[k];
      }
    },
    setOutstandingBilling(state, outstanding) {
      state.billing.outstanding = outstanding;
    },
    setBillingHistory(state, history) {
      state.billing.history = history;
    }
  },
  actions: {
    async login({ dispatch }, { login, password }) {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");

      const resp = await fetchHil(`/login-partner`, {
        method: "POST",
        headers,
        credentials: "include",
        body: { email: login, password }
      });

      if (!resp.ok) {
        throw new Error(resp.status);
      }

      const body = await resp.json();
      localStorage.setItem("hil_token", body.token);
      if (window.ReactNativeWebView != null) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            site: "PARTNER",
            token: body.token,
            type: "LOGIN"
          })
        );
      }
      dispatch("fetchStatus");
    },

    async logout({ dispatch }) {
      localStorage.removeItem("hil_token");
      if (window.ReactNativeWebView != null) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: "LOGOUT"
          })
        );
      }
      dispatch("fetchStatus");
    },

    async fetchStatus({ commit }) {
      const resp = await (await fetchHil(`/status.json`)).json();
      await commit("setUserStatus", resp);
    },

    async callbackSSO({ dispatch }, code) {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");

      const resp = await fetchHil(`/callback-sso`, {
        method: "POST",
        headers,
        credentials: "include",
        body: { code }
      });

      if (!resp.ok) {
        throw new Error(resp.status);
      }

      const body = await resp.json();
      localStorage.setItem("hil_token", body.token);
      if (window.ReactNativeWebView != null) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            site: "PARTNER",
            token: body.token,
            type: "LOGIN"
          })
        );
      }
      dispatch("fetchStatus");
    },

    async outstandingBilling({ commit }) {
      const outstanding = await fetchHil2("GET", "/user/billing/outstanding");
      await commit("setOutstandingBilling", outstanding);
    },

    async billingHistory({ commit }, { from, to }) {
      const history = await fetchHil2(
        "GET",
        `/user/billing/history?from=${from}&to=${to}`
      );
      await commit("setBillingHistory", history);
    }
  }
};
